import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';
import { quipUserShape } from '../../types';

class UnverifiedUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteUserDialogOpen: false,
    };
  }

  resetState = () => {
    this.setState({
      deleteUserDialogOpen: false,
      deleteUserId: undefined,
      deleteUserFirstName: undefined,
      deleteUserSurname: undefined,
    });
  };

  renderDeleteUserDialogActions = [
    <Button
      key="btn1"
      variant="contained"
      className="mr3"
      keyboardFocused
      onClick={() => this.props.deleteUser(this.state.deleteUserId).then(() => {
        this.resetState();
      })}
    >
      <FormattedMessage id="usermanagement.deleteUser" />
    </Button>,
    <Button
      key="btn2"
      variant="contained"
      color="secondary"
      onClick={this.resetState}
    >
      <FormattedMessage id="cancel" />
    </Button>,
  ];

  render() {
    const { users } = this.props;
    return (
      <div id="admin-details">
        {users && users.length !== 0 ? (
          <TableContainer component={Paper} variant="outlined">
            <Table aria-label="pending user table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <FormattedMessage id="registration.userFirstName" />
                  </TableCell>
                  <TableCell>
                    <FormattedMessage id="registration.userLastName" />
                  </TableCell>
                  <TableCell>
                    <FormattedMessage id="registration.institutePhone" />
                  </TableCell>
                  <TableCell>
                    <FormattedMessage id="registration.email" />
                  </TableCell>
                  <TableCell>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((unverifiedUser) => (
                  <TableRow id={`unverifiedUser-${unverifiedUser.id}`} key={unverifiedUser.id}>
                    <TableCell>
                      {unverifiedUser.firstname}
                    </TableCell>
                    <TableCell>
                      {unverifiedUser.surname}
                    </TableCell>
                    <TableCell
                      id={`unverifiedUser-email-${unverifiedUser.id}`}
                      className="unverifiedUser-email"
                    >
                      {unverifiedUser.institute && unverifiedUser.institute.phone}
                    </TableCell>
                    <TableCell>
                      {unverifiedUser.email}
                    </TableCell>
                    <TableCell className="unverifiedUser-button">
                      <Button
                        sx={{ mx: 1 }}
                        id={`unverifiedUser-changeInsitutteButton-${unverifiedUser.id}`}
                        onClick={() => this.props.resendVerification(unverifiedUser.email)}
                      >
                        <FormattedMessage id="usermanagement.resendActivation" />
                      </Button>
                      <Button
                        sx={{ mx: 1 }}
                        id={`unverifiedUser-deleteUser-${unverifiedUser.id}`}
                        onClick={() => this.setState({
                          deleteUserDialogOpen: true,
                          deleteUserId: unverifiedUser.id,
                          deleteUserFirstName: unverifiedUser.firstname,
                          deleteUserSurname: unverifiedUser.surname,
                        })}
                        color="secondary"
                      >
                        <FormattedMessage id="usermanagement.deleteUser" />
                      </Button>
                      <GenericDialog
                        actions={this.renderDeleteUserDialogActions}
                        isOpen={this.state.deleteUserDialogOpen}
                        onRequestClose={this.resetState}
                      >
                        <ContentBox
                          title={<FormattedMessage id="usermanagement.deleteUserConfirmationTitle" />}
                        >
                          <div>
                            <FormattedMessage id="usermanagement.deleteUserConfirmationText" />
                            {' '}
                            {this.state.deleteUserFirstName}
                            {' '}
                            {this.state.deleteUserSurname}
                          </div>
                        </ContentBox>
                      </GenericDialog>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <p className="green">
            <FormattedMessage id="usermanagement.nothingToDo" />
          </p>
        )}
      </div>
    );
  }
}

UnverifiedUsers.propTypes = {
  users: PropTypes.arrayOf(quipUserShape),
  resendVerification: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
};

UnverifiedUsers.defaultProps = {
  users: undefined,
};

export default UnverifiedUsers;
